import { Flex, Heading, Stack, Text } from '@chakra-ui/react';
import ProgressBar from 'components/Button/ProgressBar';

export const LoadingPage = ({
  children,
  heading,
  text,
  progress,
}: {
  heading: string;
  text: string;
  progress: number;
  children: JSX.Element;
}) => {
  return (
    <Stack align="center" style={{ height: '100%' }}>
      <Flex
        px="6"
        gap="3"
        direction="column"
        align="center"
        justify="center"
        style={{ height: '90%' }}
      >
        {children}
        <Heading fontWeight="medium" style={{ paddingTop: '30px' }}>
          {heading}
        </Heading>
        <Text
          px="0"
          gap="0"
          textAlign="center"
          style={{ whiteSpace: 'pre-line' }}
        >
          {text}
        </Text>
      </Flex>
      <ProgressBar progress={progress} />
    </Stack>
  );
};
